<template>
  <el-table :data="tableData" border>
    <el-table-column type="index" :label="$t('app.cardDetail.cardSms.serialNumber')" align="center" width="60px"></el-table-column>
    <el-table-column prop="orderNum" :label="$t('app.cardDetail.cardSms.orderNumber')" align="center" width="220"></el-table-column>
    <el-table-column prop="productName" :label="$t('app.cardDetail.cardSms.packageName')" align="center" width="220"></el-table-column>
    <el-table-column prop="use" :label="$t('app.cardDetail.cardSms.usedSms')" align="center" ></el-table-column>
    <el-table-column prop="total" :label="$t('app.cardDetail.cardSms.totalSms')" align="center"></el-table-column>
    <el-table-column prop="status" :label="$t('app.cardDetail.cardSms.packageStatus')" align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.status == '未使用'" >{{ $t('app.cardDetail.cardJftc.status.unused') }}</span>
        <span v-else-if="scope.row.status == '使用中'" >{{ $t('app.cardDetail.cardJftc.status.inUse') }}</span>
        <span v-else-if="scope.row.status == '已使用'" >{{ $t('app.cardDetail.cardJftc.status.used')  }}</span>
        <span v-else-if="scope.row.status == '已过期'" >{{ $t('app.cardDetail.cardJftc.status.expired') }}</span>
        <span v-else-if="scope.row.status == '已转移'" >{{ $t('app.cardDetail.cardJftc.status.transferred')}}</span>
        <span v-else-if="scope.row.status == '已作废'" >{{ $t('app.cardDetail.cardJftc.status.invalid') }}</span>
        <span v-else>{{ scope.row.status }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="startTime" :label="$t('app.cardDetail.cardSms.startTime')" align="center"></el-table-column>
    <el-table-column prop="endTime" :label="$t('app.cardDetail.cardSms.endTime')" align="center"></el-table-column>
  </el-table>
</template>
<script>
import { cardSmsProduct } from "@/api/api.js"; //资费列表
export default {
  props: {
    iccid: {
      type: [String]
    }
  },
  data() {
    return{
      tableData:[],
    }
  },
  watch: {
    iccid() {
      this.initData();
    }
  },

  methods: {
    // 获取列表的数据
    initData(){
      let params = {
        iccid:this.iccid
      };
      cardSmsProduct(params).then(res => {
        if(res.data.code == 200){
          this.tableData = res.data.data;
        }
      })
    },
  },
  created() {
   this.initData();
  }
};
</script>

<style scoped lang="less">

</style>


